import { ApiResponse, PageResponse } from "@/types/apis";
import request from "@/utils/request";

/** 获取成本中心列表 */
export const getCostCenter = (fdFactory: string) =>
  request.get<ApiResponse<CostCenterListItem[]>>("/sap/getCostCenter", {
    params: {
      fdFactory,
    },
  });

interface CostCenterListItem {
  /**
   * 实际值
   */
  f101: string;
  /**
   * 显示值
   */
  f102: string;
}

/** 根据传入货币和实际货币获取汇率信息 */
export const getExchangeRate = (inputCurrency: string, realCurrency: string) =>
  request.get<ApiResponse<number>>("/sap/getExchangeRate", {
    params: {
      inputCurrency,
      realCurrency,
    },
  });

/** SAP物料信息分页查询请求DTO */
export interface SrmMaterialSapPageDto {
  /** 当前页码，默认为1 */
  pageNum?: number;
  /** 每页数量，默认为10 */
  pageSize?: number;
  /** 物料号 */
  f101?: string;
  /** 物料中文描述ZF */
  f102?: string;
  /** 物料英文描述 */
  f103?: string;
  /** 物料类型 */
  f104?: string;
  /** 物料组 */
  f105?: string;
  /** 工厂值 */
  factoryValue?: string;
  /** 关键词 */
  keyword?: string;
}

/** SAP物料信息 */
export interface MaterialSapVo {
  /** 物料号 */
  f101?: string;
  /** 物料中文描述 */
  f102?: string;
  /** 物料英文描述 */
  f103?: string;
  /** 物料类型 */
  f104?: string;
  /** 物料组 */
  f105?: string;
  /** 物料等级 */
  f106?: string;
  /** 基本单位 */
  f107?: string;
  /** 安全库存 */
  f108?: string;
  /** 库存价格 */
  f109?: string;
  /** 库存 */
  f110?: string;
  /** 采购单位 */
  f111?: string;
  /** 最新采购价 */
  f112?: string;
  /** 批次管理 */
  f113?: string;
  /** 最后PO数量 */
  f114?: string;
  /** 最后PO币种 */
  f115?: string;
  /** PO价格数量单位 */
  f116?: string;
  /** 最后PO供应商 */
  f117?: string;
  /** 最后PO供应商名称 */
  f118?: string;
  /** 1年内采购均价 */
  f119?: string;
  /** 本位币 */
  f120?: string;
  /** lab/office */
  f121?: string;
  /** 物料主数据价格单位 */
  f122?: string;
  /** 物料中文描述ZH */
  f123?: string;
  /** 使用到的成品编号 */
  f131?: string;
  /** 使用到的成品（不带规格） */
  f132?: string;
  /** 中文长文本ZH */
  f133?: string;
}

/** 分页查询SAP物料信息 */
export const getSrmMaterialSapList = (data: SrmMaterialSapPageDto) =>
  request.post<PageResponse<MaterialSapVo>>(
    "/api/srmMaterialSap/pageList",
    data,
  );

/**
 * SAP物料组查询请求参数
 */
interface MaterialGroupQueryDto {
  /** 功能号，固定值M104 */
  p01?: string;
  /** 物料组，可选 */
  p02?: string;
}

/**
 * SAP物料组响应VO
 */
interface MaterialGroupVo {
  /** 物料组 */
  f101: string;
  /** 物料组描述EN */
  f102: string;
  /** 物料组描述ZF */
  f103: string;
  /** 物料组描述ZH */
  f104: string;
}

/** 获取物料组列表 sap */
export const getMaterialGroupList = (data: MaterialGroupQueryDto) =>
  request.post<ApiResponse<MaterialGroupVo[]>>("/sap/getMaterialGroup", data);

/**
 * SAP会计科目查询请求参数
 */
interface GLAccountQueryDto {
  /** 功能号，固定值M106 */
  p01?: string;
  /** 公司代码，必选，1000、0888等	 */
  p02?: string;
  /** 科目，可选 */
  p03?: string;
  /** 科目组，可选 */
  p04?: string;
}

/**
 * SAP会计科目响应VO
 */
interface GLAccountVo {
  /** 会计科目 */
  f101: string;
  /** 会计科目描述EN */
  f102: string;
  /** 会计科目描述ZF */
  f103: string;
  /** 会计科目描述ZH */
  f104: string;
}

/** 获取会计科目列表 sap */
export const getGLAccountList = (data: GLAccountQueryDto) =>
  request.post<ApiResponse<GLAccountVo[]>>("/sap/getGLAccount", data);
